/**
 * PHASES access gate — header state corrector.
 *
 * The homepage is usually served from Shopify's full-page cache, so the
 * server-rendered Locksmith unlocked/locked state can be stale there. This
 * script reads the real state from the cart's `locksmith` attribute (set by
 * Locksmith once a valid passcode is entered) and:
 *  - toggles `.phases-unlocked` on <html>
 *  - swaps the desktop menu when a "Main menu (after unlock)" is configured
 *  - swaps the header Early Access link to Login/Logout once access is granted
 * Works on any page, cached or not.
 *
 * phases-home-switch.liquid uses the same phasesGateUnlocked session key to
 * choose the homepage before this script runs, and both share one /cart.js
 * request when that check is already in flight.
 */
(function () {
  var STORAGE_KEY = "phasesGateUnlocked";

  function apply(unlocked) {
    document.documentElement.classList.toggle("phases-unlocked", unlocked);

    // Swap the desktop menu when an "after unlock" menu is configured.
    var lockedNavs = document.querySelectorAll('.header__menu[data-menu-state="locked"]');
    var unlockedNavs = document.querySelectorAll('.header__menu[data-menu-state="unlocked"]');
    for (var n = 0; n < lockedNavs.length; n++) lockedNavs[n].hidden = unlocked;
    for (var m = 0; m < unlockedNavs.length; m++) unlockedNavs[m].hidden = !unlocked;

    var wraps = document.querySelectorAll("[data-phases-access-login]");
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var link = wrap.querySelector("[data-phases-access-login-link]");
      var label = wrap.querySelector("[data-phases-access-login-label]");
      var icon = wrap.querySelector("[data-phases-access-login-icon]");
      var text = unlocked ? wrap.getAttribute("data-unlocked-text") : wrap.getAttribute("data-locked-text");
      var url = unlocked ? wrap.getAttribute("data-unlocked-url") : wrap.getAttribute("data-locked-url");

      wrap.classList.toggle("is-unlocked", unlocked);
      if (link && url) {
        link.setAttribute("href", url);
        link.setAttribute("title", text || "");
      }
      if (label && text != null) label.textContent = text;
      if (icon) {
        if (unlocked) icon.setAttribute("hidden", "");
        else icon.removeAttribute("hidden");
      }
    }
  }

  // Paint the last known state right away to avoid a flicker on cached pages.
  try {
    var cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached !== null) apply(cached === "1");
  } catch (e) {}

  function readCart() {
    if (!window.__phasesCart) {
      window.__phasesCart = fetch("/cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (r) {
          return r && r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return window.__phasesCart;
  }

  function refresh(restored) {
    // The code wall has come down for everyone (snippets/phases-wall-open.liquid): no code to look for.
    if (window.phasesWallOpen) {
      try {
        sessionStorage.setItem(STORAGE_KEY, "1");
      } catch (e) {}
      apply(true);
      dropCodeParam();
      return;
    }
    readCart().then(function (cart) {
      if (!cart) return;
      var attr = cart.attributes && cart.attributes.locksmith;
      var memory = window.phasesAccess;
      var unlocked = memory ? memory.valid(attr) : !!(attr && String(attr).trim());
      if (unlocked && memory) memory.save(attr);

      // The cart lost the code (checkout, expiry) but this browser has a valid one remembered
      // (snippets/phases-access-memory.liquid): put it back. A Locksmith gate on this page was
      // rendered for the old cart, so reload to let Locksmith open it.
      if (!unlocked && !restored && memory && memory.stored()) {
        window.__phasesCart = memory.restore();
        window.__phasesCart.then(function (updated) {
          var back = updated && updated.attributes && memory.valid(updated.attributes.locksmith);
          if (back && document.querySelector("[data-phases-access-gate], #locksmith_passcode_form")) {
            window.location.reload();
            return;
          }
          refresh(true);
        });
        return;
      }

      try {
        sessionStorage.setItem(STORAGE_KEY, unlocked ? "1" : "0");
      } catch (e) {}
      apply(unlocked);
      if (unlocked) dropCodeParam();
    });
  }

  // Locksmith reloads the URL the code was entered on, so ?code=1 (which opens the passcode
  // form) stays after unlocking. Once the page is open, tidy it out of the address bar.
  function dropCodeParam() {
    var params = new URLSearchParams(window.location.search);
    if (params.get("code") !== "1") return;
    if (document.querySelector("[data-phases-access-gate], #locksmith_passcode_form")) return;
    params.delete("code");
    var query = params.toString();
    try {
      history.replaceState(
        history.state,
        "",
        window.location.pathname + (query ? "?" + query : "") + window.location.hash,
      );
    } catch (e) {}
  }

  refresh();
})();

/**
 * Locked category collections should open the passcode form, and "Join the list"
 * on that form should leave for the pre-access landing page. Locksmith injects
 * the gate after load, so this watches for it.
 */
(function () {
  var categoryCollections = {
    "/collections/weight-body-composition-1": true,
    "/collections/weight-body-composition": true,
    "/collections/recovery-repair": true,
    "/collections/mood-cognition-intimacy": true,
  };

  function landingUrl() {
    return "/?view=landing";
  }

  function onCategoryCollection() {
    var path = window.location.pathname.replace(/\/+$/, "") || "/";
    return !!categoryCollections[path];
  }

  function showPasscode(gate) {
    gate.setAttribute("data-phases-gate-view", "passcode");
    var waitlist = gate.querySelector('[data-phases-gate-panel="waitlist"]');
    var passcode = gate.querySelector('[data-phases-gate-panel="passcode"]');
    if (waitlist) waitlist.hidden = true;
    if (passcode) passcode.hidden = false;
  }

  function pointJoinListAtLanding(gate) {
    var passcode = gate.querySelector('[data-phases-gate-panel="passcode"]');
    if (!passcode) return;
    var control = passcode.querySelector("[data-phases-gate-show='waitlist'], a.phases-access-gate__toggle");
    if (!control) return;
    if (control.tagName === "A") {
      control.setAttribute("href", landingUrl());
      return;
    }
    var link = document.createElement("a");
    link.className = control.className;
    link.href = landingUrl();
    link.textContent = control.textContent;
    control.replaceWith(link);
  }

  function fixTitle() {
    var title = (document.title || "").replace(/\s+/g, " ").trim();
    if (title.indexOf("404 Not Found") !== 0) return;
    var shopLink = document.querySelector(".phases-access-gate__logo-link");
    var shopName = (shopLink && shopLink.getAttribute("aria-label")) || "Phases";
    document.title = "Access code – " + shopName;
  }

  // T-307: a code typed into the pre-access homepage hero is handed over (sessionStorage) and submitted through
  // Locksmith's own passcode form, once Locksmith's script is ready, so Locksmith still validates it.
  function submitPendingCode(gate) {
    var code = null;
    try {
      code = sessionStorage.getItem("phasesPendingCode");
      sessionStorage.removeItem("phasesPendingCode");
    } catch (e) {}
    if (!code) return;
    var form = document.getElementById("locksmith_passcode_form");
    var input = form && form.querySelector('input[name="passcode"]');
    if (!input) return;
    showPasscode(gate);
    input.value = code;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    var tries = 0;
    (function submitWhenReady() {
      if (!window.Locksmith && tries++ < 50) {
        setTimeout(submitWhenReady, 100);
        return;
      }
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        var button = form.querySelector('[type="submit"]');
        if (button) button.click();
      }
    })();
  }

  function scan() {
    fixTitle();
    var gate = document.querySelector("[data-phases-access-gate]");
    if (!gate || gate.getAttribute("data-phases-gate-corrected") === "1") return;
    if (!gate.querySelector('[data-phases-gate-panel="passcode"]')) return;
    gate.setAttribute("data-phases-gate-corrected", "1");
    if (onCategoryCollection()) showPasscode(gate);
    pointJoinListAtLanding(gate);
    submitPendingCode(gate);
    observer.disconnect();
  }

  // A wrong code: Locksmith swaps the designed gate for its bare default form (field outlined red + Continue, no
  // message and no way back). Send the visitor back to the landing page, where the hero code entry says the code
  // didn't work (snippets/phases-hero-code-entry.liquid).
  function handleFailedCode() {
    if (!document.querySelector(".locksmith-authorization-failed")) return false;
    if (document.querySelector("[data-phases-access-gate]")) return false;
    window.location.replace(landingUrl() + "&access=invalid");
    return true;
  }

  if (document.getElementById("locksmith-content") || document.getElementById("locksmith_passcode_form")) {
    var failedObserver = new MutationObserver(function () {
      if (handleFailedCode()) failedObserver.disconnect();
    });
    failedObserver.observe(document.body, { childList: true, subtree: true });
    handleFailedCode();
  }

  var observer = new MutationObserver(scan);
  var root = document.getElementById("MainContent") || document.body;
  if (root) observer.observe(root, { childList: true, subtree: true });
  scan();
  setTimeout(function () {
    observer.disconnect();
  }, 8000);
})();
